import { render, staticRenderFns } from "./DEPALT.vue?vue&type=template&id=db43fe56&scoped=true&"
import script from "./DEPALT.vue?vue&type=script&lang=js&"
export * from "./DEPALT.vue?vue&type=script&lang=js&"
import style0 from "./DEPALT.vue?vue&type=style&index=0&id=db43fe56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db43fe56",
  null
  
)

export default component.exports